import { GTM_ID } from '../../../common/constants/gtmIds';
import vars from '../variables';

// @TODO defineGrid is deprecated in favour of defineResponsiveGridColumns
export const defineGrid = (sizes = [], type, unit = 'rem') => {
  if (sizes.length < 1) {
    return null;
  }
  const strictType = type === 'row' ? 'row' : 'col';
  let output = `[${strictType}1-start] `;
  sizes.forEach((size, index) => {
    output += `${size}${unit}`;
    if (index + 1 === sizes.length) {
      output += `[${strictType}${index + 1}-end]`;
    } else {
      output += `[${strictType}${index + 1}-end ${strictType}${index + 2
        }-start] `;
    }
  });
  return output;
  //@TODO typechecking for non-react components
};

export const defineResponsiveGridColumns = numColumns => {
  if (Number.isInteger(numColumns) && numColumns > 0) {
    let output = `[col1-start] `;
    for (let i = 1; i < numColumns; i += 1) {
      output += `1fr [col${i}-end col${i + 1}-start] `;
    }
    output += `1fr [col${numColumns}-end]`;
    return output;
  }
  console.error(
    `defineResponsiveGridColumns called with invalid argument: ${numColumns}`
  );
  return null;
};

export const createFilterList = (content, parameter) => {
  // create unique array for filters
  let contentArray = [];

  content.forEach(entry => {
    contentArray.push(entry[parameter]);
  });

  let contentSet = [...new Set(contentArray)];

  let uniqueArray = Array.from(contentSet).sort();

  return uniqueArray;
};

export function getTagColour({ title }) {
  if (typeof title !== 'string') {
    return undefined;
  }
  switch (title.toLowerCase()) {
    case 'design':
      return vars.designStrongYellow;
    case 'fashion':
      return vars.fashionPurple;
    case 'finance':
      return vars.financePink;
    case 'food':
      return vars.foodOrange;
    case 'learning':
      return vars.learningGreen;
    case 'plastics':
      return vars.plasticsBlue;
    case 'policy':
      return vars.policyGrey;
    case 'cities':
      return vars.citiesGreen;
    case 'built environment':
      return vars.builtEnvRed;
    case 'emf':
    case 'core':
    default:
      return vars.coreDarkGrey;
  }
}

export const trimDescription = (description, maxLength) => {
  if (description.length < 1 || maxLength < 1) {
    return null;
  }
  if (description.length > maxLength) {
    var trimmedDescription = description.substr(0, maxLength);
    trimmedDescription =
      trimmedDescription.substr(
        0,
        Math.min(trimmedDescription.length, trimmedDescription.lastIndexOf(' '))
      ) + '...';
    return trimmedDescription;
  }
  return description;
};

export const convertStringToArray = (inputString, separator = '\n') => {
  if (typeof inputString === 'string' && inputString.length) {
    const array = inputString.split(separator);
    const trimmedArray = array.map(element => element.trim());
    return trimmedArray;
  } else {
    console.warn(
      `helper-functions -> convertStringToArray received non valid argument - inputString: `,
      inputString
    );
    return [];
  }
};

/* 
  This is a duplicate of fn from site/src/utils/string-helper-functions.js
  Recreating here as:
    i)   It is needed in both site and design system
    ii)  It is not a natural fit for it to sit in just design-system
  @TODO suggested refactor to create a shared common project, containing all such common helper functions,
  which both site and design-system would have a dependency on 🌴
*/

export const convertStringToBoolean = inputString => {
  if (typeof inputString === 'string') {
    if (inputString.toLowerCase() === 'true') {
      return true;
    } else if (inputString.toLowerCase() === 'false') {
      return false;
    }
  }
  return undefined;
};

export const convertStringToFloat = inputString => {
  if (inputString) {
    return Math.round(parseFloat(inputString) * 10) / 10;
  } else {
    return 0;
  }
};

export const createYoutubeEmbedUrl = url => {
  let id;
  const options = 'wmode=opaque&rel=0&showinfo=0&modestbranding=1&color=white';
  if (url.includes('embed')) {
    return `${url}?${options}`;
  }
  if (url.includes('?v=')) {
    id = url.split('?v=')[1].split('&')[0];
  }
  if (url.includes('youtu.be/')) {
    id = url.split('youtu.be/')[1];
  }
  return id
    ? `https://www.youtube.com/embed/${id}?${options}`
    : console.error(`Invalid youtube link input ${url}`);
};

export const createVimeoEmbedUrl = url => {
  const vimeoBaseUrl = 'https://vimeo.com/';

  return url.replace(vimeoBaseUrl, 'https://player.vimeo.com/video/');
};

export const generateKey = (inputString, index) => {
  try {
    if (inputString) {
      while (inputString.length < 10) {
        inputString += inputString;
      }

      return `${inputString.slice(0, 10)}-${index}`;
    } else {
      return `generic-${index}`;
    }
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getPercentageValue = (value, max) => (value / max) * 100;

/* 
  This is a duplicate of fn from site/src/utils/string-helper-functions.js
  Recreating here as:
    i)   It is needed in both site and design system
    ii)  It is not a natural fit for it to sit in just design-system
  @TODO suggested refactor to create a shared common project, containing all such common helper functions,
  which both site and design-system would have a dependency on 🌴
*/

const accentCharTranslations = {
  à: 'a',
  á: 'a',
  â: 'a',
  ä: 'a',
  æ: 'a',
  ã: 'a',
  å: 'a',
  ā: 'a',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  ē: 'e',
  ė: 'e',
  ę: 'e',
  î: 'i',
  ï: 'i',
  í: 'i',
  ī: 'i',
  į: 'i',
  ì: 'i',
  ô: 'o',
  ö: 'o',
  ò: 'o',
  ó: 'o',
  œ: 'o',
  ø: 'o',
  ō: 'o',
  õ: 'o',
  û: 'u',
  ü: 'u',
  ù: 'u',
  ú: 'u',
  ū: 'u',
  ç: 'c',
  ć: 'c',
  č: 'c',
  l: 'l',
  ñ: 'n',
  ń: 'n',
  ś: 's',
  š: 's',
  ÿ: 'y',
  ž: 'z',
  ź: 'z',
  ż: 'z',
};

export const replaceAccentedCharacters = inputString => {
  if (typeof inputString === 'string') {
    return inputString
      .toLowerCase()
      .split('')
      .map(char => {
        return accentCharTranslations[char]
          ? accentCharTranslations[char]
          : char;
      })
      .join('');
  } else {
    console.warn(
      `string-helper-functions -> replaceAccentedCharacters: error, function called with non valid argument - inputString:`,
      inputString
    );
    return undefined;
  }
};

export const formatNumberWithCommas = aNumber => {
  if (!aNumber) {
    return '';
  } else {
    return aNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

export const getGtmLinkId = link => {
  const emfContentSources = [
    'emf.thirdlight.com',
    'ellenmacarthurfoundation.typeform.com',
    'emf.org',
    'africa-hub.emf.org',
    'community.emf.org',
    'ellenmacarthurfoundation.org',
    'archive.ellenmacarthurfoundation.org',
    'ellenmacarthurfoundation.wufoo.com',
    'the-circular-economy-podcast.simplecast.com',
    'circulardesignfashion.emf.org',
    'medium.com/circulatenews',
    'forms.gle',
    'addevent.com',
    'climate.ellenmacarthurfoundation.org',
    'plastics.ellenmacarthurfoundation.org',
    'forms.gle',
    'addevent.com',
    'circulardesignguide.com',
    'emf.gitbook.io',
    'newplasticseconomy.org',
    'made2bmadeagain.org',
    'rescoms.eu',
  ];

  let gtmId = 'external-link';
  const regex = /^\/[^/]+.*$/gm; // Matches single '/'
  if (link?.match(regex) || link === '/') {
    gtmId = GTM_ID.INTERNAL_LINK;
  } else {
    emfContentSources.forEach(domain => {
      if (link?.includes(domain)) {
        gtmId = GTM_ID.INTERNAL_LINK;
        return;
      }
    });
  }

  return gtmId;
};

export const doesUrlHaveAnchorId = (href, anchorId) =>
  new URL(href).hash === `#${anchorId}`;

export const validateCanonicalLinkWithLocale = (linkUrl, locale) => {
  if (linkUrl) {
    if (locale && locale !== 'en-GB') {
      const localeRegex = new RegExp(
        `https:\\/\\/(www\\.)?ellenmacarthurfoundation\\.org\\/${locale}\\/|\\/${locale}$`
      );
      return localeRegex.test(linkUrl);
    }
    return locale === 'en-GB';
  } else {
    return false;
  }
};

export const shouldForwardProp = (props, prop) => !props.includes(prop);
